import util from "../utils/util";

export function buildImgSrc(item) {
  let allinfo = util.getStoObj("allinfo");
  let url = item.ImgUrl || item.ProdPackURl || "";

  if (url) {
    item.ImgUrlOne = allinfo.DomainUrl + url.split(",")[0];
  } else {
    item.ImgUrlOne = "";
  }

  return item;
}

export function templateRender(str, data) {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const val = data[key];
      str = str.replace(new RegExp(`\{\{${key}\}\}`, "g"), data[key]);
    }
  }
  return str;
}
